import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UseAlert } from '../../../presentation/hook/AlertHook';

import { PrivateRoutes } from '../../../main/constant/RouteConstant';
import MessageConstant from '../../../main/constant/MessageConstant';

import { ProfessionalUseCase } from '../../../data/useCase/ProfessionalUseCase';

import { AddProfessional, EditProfessional } from '../../../presentation/page/addProfessional/AddProfessionalPageType';

import { PaginationType } from '../../contract/Pagination';

import AddProfessionalPage from '../../../presentation/page/addProfessional/AddProfessionalPage';

import { HttpStatusCodeEnum } from '../../enums/HttpStatusCodeEnum';
import { AddressUseCase } from '../../../data/useCase/AddressUseCase';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';

/**
 * AddProfessionalPageDomain - regra de negocio de profissional
 * @constructor
 */
export const AddProfessionalPageDomain: React.FC = () => {
  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  let PAGE = 0;
  let PAGE_SIZE = 10;

  /**
   * endpoint
   */
  const ENDPOINT_PROFESSIONAL = EndpointsConstant.professional;
  const ENDPOINT_SPECIALTIES = EndpointsConstant.specialties;

  /**
   * model
   */
  const [professional, setProfessional] = useState<null>(null);
  const [professionalSpecialties, setProfessionalSpecialties] = useState<[]>([]);
  const [clinicSpecialties, setClinicSpecialties] = useState<[]>([]);
  const [specialtiesList, setSpecialties] = useState<[]>([]);

  /**
   * paginacao
   */
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  /**
   * navegacao da url
   */
  let navigate = useNavigate();

  /**
   * parametros da url
   */
  const urlParams = useParams();

  /**
   * add
   * @param params
   */
  const add = async (params: AddProfessional) => {
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/`)
      .Post({ data: params })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  /**
   * edit
   * @param params
   */
  const edit = async (params: EditProfessional) => {
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/${params.id}`)
      .Put({ data: params })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  /**
   * comeBack - voltar
   */
  const comeBack = () => {
    navigate(PrivateRoutes.LIST_PROFESSIONAL);
  };

  /**
   * getProfessional - busca profissional
   * @param id
   */
  const getProfessional = async (id: number) => {
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/${id}`)
      .Get()
      .then((response) => {
        setProfessional(response.body);
      })
      .catch((error) => {
        showAlert({
          show: true,
          content: MessageConstant.erro.generico,
          color: 'danger',
          time: 2000,
        });
        console.error('ERRO: ', error);
      });
  };

  /**
   * getspecialties
   */
  const getSpecialties = async () => {
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/specialties?page=${PAGE}&pageSize=${PAGE_SIZE}`)
      .Get()
      .then((response) => {
        setSpecialties(response.body.items);
        setPagination({
          pageIndex: response.body.pageIndex,
          pageSize: response.body.pageSize,
          totalCount: response.body.totalCount,
          totalPages: response.body.totalPages,
          hasPreviousPage: response.body.hasPreviousPage,
          hasNextPage: response.body.hasNextPage,
          onClickItem: handleClickPagination,
        });
      })
      .catch((error) => {
        showAlert({
          show: true,
          content: MessageConstant.erro.generico,
          color: 'danger',
          time: 2000,
        });
        console.error('ERRO: ', error);
      });
  };

  const getSpecialtiesByUser = async (id: number) => {
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/specialties/enumeration/${id}`)
      .Get()
      .then((response) => {
        setProfessionalSpecialties(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  const getSpecialtiesV2 = async () => {
    await new ProfessionalUseCase(`${ENDPOINT_SPECIALTIES}/enumeration`)
      .Get()
      .then((response) => {
        setSpecialties(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  const getClinicSpecialtiesFilter = async (name: string) => {
    await new ProfessionalUseCase(`${ENDPOINT_SPECIALTIES}/enumeration/${name}`)
      .Get()
      .then((response) => {
        setSpecialties(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  const addSpecialtiesProfessional = async (specialty: { description: string; id: number }) => {
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/specialties`)
      .Post({
        data: {
          professionalId: urlParams.id,
          specialtyId: specialty.id,
        },
      })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
            getSpecialtiesByUser(Number(urlParams.id));
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  const removeSpecialties = async (specialty: { description: string; id: number }) => {
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/specialties/${specialty.id}`)
      .Delete()
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
            getSpecialtiesByUser(Number(urlParams.id));
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  const addSpecialtiesClinic = async (specialty: { description: string }) => {
    await new ProfessionalUseCase(`${ENDPOINT_SPECIALTIES}`)
      .Post({
        data: {
          clinicId: 0,
          description: specialty.description,
          rangeStart: 0,
          rangeEnd: 0,
        },
      })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
            getSpecialtiesByUser(Number(urlParams.id));
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });

    await getSpecialtiesV2();
  };

  /**
   * handleClickPagination
   * @param id
   */
  const handleClickPagination = async (id: number) => {
    PAGE = id;
    await getSpecialties();
  };

  /**
   * inicia preenchendo o profissional caso tem um id na url
   */
  const init = async () => {
    if (urlParams.id) {
      await getProfessional(Number(urlParams.id));
      await getSpecialtiesByUser(Number(urlParams.id));
    }
    await getSpecialtiesV2();
  };

  /**
   * inicio
   */
  useEffect(() => {
    init();
  }, []);

  /**
   * endpoint de endereço
   */
  const ENDPOINT_ADDRESS = EndpointsConstant.address;

  /**
   * model endereco
   */
  const [endereco, setEndereco] = useState<null>(null);

  const getAddress = async (cep: string) => {
    await new AddressUseCase(`${ENDPOINT_ADDRESS}/${cep}`)
      .Get()
      .then((response) => {
        console.info('RESPONSE: ', response);
        setEndereco(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
      });
  };

  return (
    <>
      <AddProfessionalPage
        add={add}
        edit={edit}
        comeBack={comeBack}
        professional={professional}
        getProfessional={getProfessional}
        professionalSpecialties={professionalSpecialties}
        clinicSpecialties={clinicSpecialties}
        clinicSpecialtiesFilter={getClinicSpecialtiesFilter}
        getclinicSpecialties={getSpecialtiesV2}
        specialtiesList={specialtiesList}
        specialtiesPagination={pagination}
        addSpecialties={addSpecialtiesProfessional}
        removeSpecialties={removeSpecialties}
        addSpecialtiesClinic={addSpecialtiesClinic}
        getAddress={getAddress}
        address={endereco}
      />
    </>
  );
};
